var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import RESTAdapter from '@ember-data/adapter/rest';
import { baseRpcUrl } from '@square/dashboard-utilities/utils/url';
import { getCsrfToken } from '@square/dashboard-utilities/utils/csrf';
import { inject as service } from '@ember/service';
let Vendor = (_class = class Vendor extends RESTAdapter {
  constructor(args) {
    super(args);
    _initializerDefineProperty(this, "features", _descriptor, this);
    _defineProperty(this, "host", baseRpcUrl(''));
    _defineProperty(this, "headers", {
      'X-CSRF-Token': getCsrfToken()
    });
    this.useFetch = false;
  }
  ajaxOptions(url, method, options) {
    // We need to set this for CORS requests
    const optionsWithCredentials = options;
    optionsWithCredentials.xhrFields = {
      withCredentials: true
    };
    return super.ajaxOptions(url, method, optionsWithCredentials);
  }
  pathForType() {
    return 'api/v2/inventory/vendors';
  }
  shouldBackgroundReloadRecord() {
    return false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Vendor as default };